import api from "./axios";

const API_URL = "/users";

export const getUsers = (teamId = null) => {
  const params = teamId ? { team_id: teamId } : {};
  return api.get(API_URL, { params });
};

export const getStudentUsers = (teamId = null) => {
  const params = teamId ? { team_id: teamId } : {};
  return api.get(`${API_URL}/students`, { params });
};
export const getProfessorUsers = () => api.get(`${API_URL}/professors`);

export const getUser = (id) => api.get(`${API_URL}/${id}`);
export const createUser = (user) => api.post(API_URL, user);
export const updateUser = (id, user) => api.put(`${API_URL}/${id}`, user);
export const updateUserOverallGrade = (id, payloadOrOverallGrade) => {
  const payload =
    typeof payloadOrOverallGrade === "object" && payloadOrOverallGrade !== null
      ? payloadOrOverallGrade
      : { overall_grade: payloadOrOverallGrade };

  return api.patch(`${API_URL}/${id}/overall-grade`, payload);
};
export const deleteUser = (id) => api.delete(`${API_URL}/${id}`);
export const getUserEvaluation = (userId) => api.get(`${API_URL}/${userId}/evaluation`);
export const getCurrentUser = () => api.get(`${API_URL}/me`);
